<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px" />
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label for="form_no">TNA Form No.</label>
                                <input type="number" v-model="search_data.form_no" v-validate="{ regex: /^[0-9]+$/ }"
                                    id="form_no" name="form_no" class="form-control form-control-sm"
                                    placeholder="Search by form No" />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label for="household_number">Household Number</label>
                                <input type="text" v-model="search_data.household_number" id="household_number"
                                    name="household_number" class="form-control form-control-sm"
                                    placeholder="Search by HH No" />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label for="name">Household Head Name</label>
                                <input type="text" v-model="search_data.name" id="name" name="name"
                                    class="form-control form-control-sm" placeholder="Search by Name" />
                            </div>
                        </div>
                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label for="c_mouza_id">Mouza</label>
                                <select v-model="search_data.c_mouza_id" class="form-control form-control-sm"
                                    name="c_mouza_id" id="c_mouza_id">
                                    <option selected :value="''">Select a Mouza</option>
                                    <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id">{{ mouza.id }} :
                                        {{ mouza.desc }}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label for="c_village_id">Village</label>
                                <select v-model="search_data.c_village_id" id="c_village_id" name="c_village_id"
                                    class="form-control form-control-sm">
                                    <option selected :value="''">Select a village</option>
                                    <option v-for="(village, index) in villages" :key="index" :value="village.id">{{
                                        village.id }} : {{ village.desc }}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label for="batch_id">Batch</label>
                                <select v-model="search_data.batch_id" id="batch_id" name="batch_id"
                                    class="form-control form-control-sm">
                                    <option :value="''" selected>Select Batch</option>
                                    <option v-for="(batch, index) in batches" :key="index" :value="batch.id">
                                        {{ batch.trade.desc + " | " + "Batch No: " + batch.batch_no }}</option>
                                </select>
                            </div>
                        </div>
                        <button @click.prevent="search()" class="btn btn-success btn-sm mt-2">Search</button>
                    </form>
                </b-card>


                <b-card>
                    <div v-if="trainees.total > 0" class="row mb-2">
                        <div class="col-sm-12">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ trainees.total }}</span>
                            <b-dropdown variant="default" style=" background-color: #d4d4d4; border-color: #8c8c8c;">
                                <template v-slot:button-content>
                                    <i class="fa fa-cog"></i>
                                </template>
                                <b-dropdown-form style="width: 207px !important; overflow-y: auto">
                                    <span v-for="(checkboxArray, index) in checkboxArrays" :key="index" class="ml-3">
                                        <input type="checkbox" v-model="selected" :value="checkboxArray"
                                            :id="checkboxArray">&nbsp;{{ checkboxArray }} <br>
                                    </span>
                                </b-dropdown-form>
                            </b-dropdown>
                            <download-excel class="btn btn-light float-right" :fetch="fetchData" :fields="trainee_fields"
                                :meta="json_meta" :before-generate="startDownload" :before-finish="finishDownload"
                                worksheet="Trainee" name="trainee-batch.xls">
                                <span v-if="loading" class="spinner-border spinner-border-sm text-muted"
                                    style="margin-bottom :  2px;"></span>,
                                <span style="cursor : pointer;">Download Trainee With Batch</span>
                            </download-excel>
                            <button class="btn btn-light float-right mr-1" @click="dowonloadPdf">
                                <div v-if="spinner" class="spinner-border spinner-border-sm text-muted"
                                    style="margin-bottom : 2px;">
                                </div>
                                Download PDF
                            </button>
                        </div>
                    </div>

                    <div class="scrollable-table table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>Trainee ID</th>
                                    <th v-if="isVisible('Form No.')">Form No.</th>
                                    <th v-if="isVisible('Household Number')">Household Number</th>
                                    <th v-if="isVisible('Name')">Name</th>
                                    <th v-if="isVisible('NID')">NID(ID Type)</th>
                                    <th v-if="isVisible('Mobile')">Mobile</th>
                                    <th v-if="isVisible('Gender')">Gender</th>
                                    <th v-if="isVisible('Father Name')">Father Name</th>
                                    <th v-if="isVisible('Mother Name')">Mother Name</th>
                                    <th v-if="isVisible('Village')">Village</th>
                                    <th v-if="isVisible('Mouza')">Mouza</th>
                                    <th v-if="isVisible('Rep Name')">Rep. Name</th>
                                    <th v-if="isVisible('Rep Father Name')">Rep. Father/Husband Name</th>
                                    <th v-if="isVisible('Rep Mother Name')">Rep Mother Name</th>
                                    <th v-if="isVisible('Rep Relation')">Rep Relation</th>
                                    <th v-if="isVisible('Rep DOB')">Rep DOB</th>
                                    <th v-if="isVisible('Rep Gender')">Rep Gender</th>
                                    <th v-if="isVisible('Rep NID')">Rep NID</th>
                                    <th v-if="isVisible('Rep Mobile')">Rep Mobile</th>
                                    <th v-if="isVisible('Field Book')">Field Book</th>
                                    <th v-if="isVisible('Batch')">Batch</th>
                                    <th v-if="isVisible('Package')">Package</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(trainee, index) in trainees.data" :key="index">
                                    <td>{{ trainees.from + index }}</td>
                                    <td><span v-if="trainee.mouza.id < 10">0{{ trainee.mouza.id }}</span><span v-else>{{
                                        trainee.mouza.id }}</span>{{ trainee.union.id }}{{ trainee.c_training_trade_id
    }}{{ trainee.batch_no }}{{ trainee.form_no }}</td>
                                    <td v-if="isVisible('Form No.')">{{ trainee.form_no }}</td>
                                    <td v-if="isVisible('Household Number')">{{ trainee.household_number }}</td>
                                    <td v-if="isVisible('Name')">
                                        <router-link :to="{ name: 'traineeView', params: { trainee_id: trainee.id } }" tag="a"
                                            title="Trainee Details" target="_blank">
                                            <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                                                <span v-if="image.file_tag === '1'">
                                                    <img class="rounded-circle" :src="image.name" alt="" width="30px"
                                                        height="30px" />
                                                </span>
                                            </span>
                                            {{ trainee.name }}
                                        </router-link>
                                    </td>
                                    <td v-if="isVisible('NID')">{{ trainee.nid }}({{ trainee.id_type }})</td>
                                    <td v-if="isVisible('Mobile')">{{ trainee.mobile }}</td>
                                    <td v-if="isVisible('Gender')">{{ trainee.gender.desc }}</td>
                                    <td v-if="isVisible('Father Name')">{{ trainee.father_husband_name }}</td>
                                    <td v-if="isVisible('Mother Name')">{{ trainee.mother_name }}</td>
                                    <td v-if="isVisible('Village')">{{ trainee.village.desc }}</td>
                                    <td v-if="isVisible('Mouza')">{{ trainee.mouza.desc }}</td>
                                    <td v-if="isVisible('Rep Name')">
                                        <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                                            <span v-if="image.file_tag === '2'">
                                                <img class="rounded-circle" :src="image.name" alt="" width="30px"
                                                    height="30px" />
                                            </span>
                                        </span>
                                        {{ trainee.rep_name }}
                                    </td>
                                    <td v-if="isVisible('Rep Father Name')">{{ trainee.rep_father_husband_name }}</td>
                                    <td v-if="isVisible('Rep Mother Name')">{{ trainee.rep_mother_name }}</td>
                                    <td v-if="isVisible('Rep Relation')"><span v-if="trainee.family_relation !== null">{{
                                        trainee.family_relation.desc }}</span></td>
                                    <td v-if="isVisible('Rep DOB')">{{ trainee.rep_dob }}</td>
                                    <td v-if="isVisible('Rep Gender')"><span v-if="trainee.rep_gender !== null">{{
                                        trainee.rep_gender.desc }}</span></td>
                                    <td v-if="isVisible('Rep NID')"><span v-if="trainee.rep_nid !== null">{{ trainee.rep_nid
                                    }}({{ trainee.rep_id_type }})</span></td>
                                    <td v-if="isVisible('Rep Mobile')">{{ trainee.rep_mobile }}</td>
                                    <td v-if="isVisible('Field Book')">{{ trainee.field_book_sl }}</td>
                                    <td v-if="isVisible('Batch')">{{ trainee.trade_desc + " | " + "Batch No: " +
                                        trainee.batch_no }}</td>
                                    <td v-if="isVisible('Package')">{{ trainee.package_desc }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h5 v-if="trainees.total == 0" class="text-center text-secondary">
                        No Data Found
                    </h5>
                    <div class="float-right">
                        <pagination :data="trainees" :limit="2" @pagination-change-page="getResults"></pagination>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
    page: {
        title: "Trainee List",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Search Trainee",
            items: [
                {
                    text: "Dashboard",
                    href: "/"
                },
                {
                    text: "Trainee",
                    active: true
                }
            ],
            loading: false,
            trainees: {},
            search_data: {
                form_no: '',
                household_number: '',
                name: '',
                c_village_id: '',
                c_mouza_id: '',
                batch_id: '',
            },
            spinner: false,
            villages: [],
            batches: [],
            mouzas: [],
            trainee: {},
            trainee_fields: {
                'Form No': 'form_no',
                'Household Number': 'household_number',
                'Name': 'name',
                'ID Type': 'id_type',
                'NID': 'nid',
                'Mobile': 'mobile',
                'Date of Birth': 'dob',
                'Gender': 'gender.desc',
                'Father Name': 'father_husband_name',
                'Mother Name': 'mother_name',
                'Marital': 'maritial_status.desc',
                'Religion': 'religion.desc',
                'Education': 'education.desc',
                'Occupation': 'occupation.desc',
                'Yearly Income': 'yearly_income',
                'Village': 'village.desc',
                'Mouza': 'mouza.desc',
                'Union': 'union.desc',
                'Affected Plot': 'affected_plots',
                'Affected Khatians': 'affected_khatians',
                'Affected Mouzas': 'affected_mouzas',
                'Previous Training': {
                    callback: (value) => {
                        if (value.previous_training === 0) {
                            return `No`;
                        } else {
                            return `Yes`;
                        }
                    }
                },
                'Previous Training Duration': 'previous_training_duration',
                'Specific Skills': 'specific_skills',
                'Rep. Name': 'rep_name',
                'Rep Gender': {
                    callback: (value) => {
                        if (value.rep_gender !== null) {
                            return `${value.rep_gender.desc}`;
                        } else {
                            return ``;
                        }
                    }
                },
                'Rep DOB': 'rep_dob',
                'Rep Father Name': 'rep_father_husband_name',
                'Rep Mother Name': 'rep_mother_name',
                'Rep Marital': {
                    callback: (value) => {
                        if (value.rep_maritial_tatus !== null) {
                            return `${value.rep_maritial_tatus.desc}`;
                        } else {
                            return ``;
                        }
                    }
                },
                'Rep Religion': {
                    callback: (value) => {
                        if (value.rep_religion !== null) {
                            return `${value.rep_religion.desc}`;
                        } else {
                            return ``;
                        }
                    }
                },
                'Rep Education': {
                    callback: (value) => {
                        if (value.rep_education !== null) {
                            return `${value.rep_education.desc}`;
                        } else {
                            return ``;
                        }
                    }
                },
                'Rep Occupation': {
                    callback: (value) => {
                        if (value.rep_occupation !== null) {
                            return `${value.rep_occupation.desc}`;
                        } else {
                            return ``;
                        }
                    }
                },
                'Rep Relation': {
                    callback: (value) => {
                        if (value.family_relation !== null) {
                            return `${value.family_relation.desc}`;
                        } else {
                            return ``;
                        }
                    }
                },
                'Rep ID Type': {
                    callback: (value) => {
                        if (value.rep_nid !== null) {
                            return `${value.rep_id_type}`;
                        } else {
                            return ``;
                        }
                    }
                },
                'Rep NID': {
                    callback: (value) => {
                        if (value.rep_nid !== null) {
                            return `${value.rep_nid}`;
                        } else {
                            return ``;
                        }
                    }
                },
                'Rep Mobile': 'rep_mobile',
                'Field Book': 'field_book_nos',
                'Field Book Sub No.': 'filed_book_sub_nos',
                'Batch': {
                    callback: (value) => {
                        return `${value.trade_desc} | Batch No: ${value.batch_no}`;
                    }
                },
                'Package': 'package_desc',
            },
            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ],
            flag: false,
            checkboxArrays: ['Form No.', 'Household Number', 'Name', 'NID', 'Mobile', 'Gender', 'Father Name', 'Mother Name', 'Village', 'Mouza', 'Rep Name', 'Rep Father Name', 'Rep Mother Name', 'Rep Relation', 'Rep DOB', 'Rep Gender', 'Rep NID', 'Rep Mobile', 'Field Book', 'Batch', 'Package'],
            selected: ['Form No.', 'Household Number', 'Name', 'Father Name', 'Village', 'Rep Name', 'Rep Father Name', 'Batch'],
        };
    },


    mounted() {
        this.getCodes();
    },
    methods: {
        async dowonloadPdf() {
            this.spinner = true
            let response = await http.post("api/batch/trainees/download_trainees", this.search_data);
            var data = []
            try {
                response.data.trainees.forEach(function (value) {
                    data.push([
                        value.form_no,
                        value.household_number,
                        value.name,
                        value.father_husband_name,
                        value.mother_name,
                        value.rep_name,
                        value.nid,
                        value.mobile,
                        value.dob,
                        value.gender.desc
                    ])
                })
            }
            catch (e) {
                console.log(e.message)
            }

            const doc = new jsPDF({ orientation: 'l' })
            autoTable(doc, {
                head: [['Form no', 'HH nom', 'Name', 'Father/Husband name', 'Mother name', 'Rep name', 'NID', 'Mobile', 'DOB', Gender]],
                body: data,
            })
            doc.save('all-batch-trainee.pdf')
            this.spinner = false
        },
        getCodes() {
            http.get("api/ses/codes").then(response => {
                if (!response.error) {
                    let data = response.data;
                    this.villages = data.villages;
                    this.mouzas = data.mouzas;
                    this.batches = data.batches;
                }
            });
        },
        async search() {
            await http.post("api/batch/trainees/search", this.search_data).then(response => {
                if (!response.error) {
                    this.flag = true;
                    this.trainees = response.data.trainees;
                }
            });
        },
        async getResults(page = 1) {
            await http.post('api/batch/trainees/search?page=' + page, this.search_data)
                .then(response => {
                    this.flag = true;
                    this.trainees = response.data.trainees;
                });
        },
        async fetchData() {
            const response = await http.post("api/batch/trainees/download_trainees", this.search_data);
            return response.data.trainees;
        },
        startDownload() {
            this.loading = true
        },
        finishDownload() {
            this.loading = false
        },
        isVisible(row) {
            const matchedValue = this.checkboxArrays.find(
                v => row === v
            );

            if (!matchedValue) {
                return true;
            }
            return this.selected.includes(matchedValue);
        }
    },
    computed: {
        userPermission() {
            return this.$store.state.user
        }
    },
    created() {
        this.$store.dispatch('getUserPermission')
    },
};
</script>
